import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import React from "react";

const TermsAndConditionsModal = ({
  isAllTermsAndConditions,
  setNewTC,
  setOpenTCModal,
  isPOData,
  newTC,
  openTCModal,
  setOpenCreateTCModal,
  toggleTerm,
  openCreateTCModal,
  createTermsCondition,
  disableButtonCheck,
  errors,
}) => {
  return (
    <div>
      <div>
        <label className="mb-2 block text-lg font-semibold">
          Terms & Conditions
        </label>

        <button
          type="button"
          onClick={() => setOpenTCModal(true)}
          className="
            flex
            w-full
            
            items-center
            justify-between
            rounded-md
            border
            border-gray-300
            bg-white
            p-3
            text-left
          "
        >
          <span>
            {isPOData?.termsAndConditionsId?.length > 0
              ? `${isPOData.termsAndConditionsId?.length} Terms Selected`
              : "Select T&C"}
          </span>
          <span>▼</span>
        </button>

        {errors.termsAndConditionsId && (
          <p className="mt-1 text-sm text-red-500">
            {errors.termsAndConditionsId}
          </p>
        )}
      </div>
      {
        <Dialog
          open={openTCModal}
          onClose={() => setOpenTCModal(false)}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>Select Terms & Conditions</DialogTitle>

          <DialogContent dividers>
            <div
              onClick={() => setOpenCreateTCModal(true)}
              className="cursor-pointer mb-2 rounded-lg border-2 border-dashed border-blue-300 p-6 text-center hover:bg-blue-50"
            >
              <h3 className="font-semibold text-blue-600">
                + Create Terms & Conditions
              </h3>
            </div>
            <div className="space-y-4">
              {isAllTermsAndConditions?.length > 0 ? (
                isAllTermsAndConditions.map((item) => (
                  <div
                    key={item._id}
                    onClick={() => {
                      toggleTerm(item._id);
                    }}
                    className="cursor-pointer rounded-lg border p-4 transition hover:bg-gray-50"
                  >
                    <div className="flex items-start gap-3">
                      <Checkbox
                        checked={
                          Array.isArray(isPOData?.termsAndConditionsId) &&
                          isPOData.termsAndConditionsId.some((term) =>
                            typeof term === "string"
                              ? term === item._id
                              : term._id === item._id,
                          )
                        }
                      />
                      <div>
                        <h3 className="font-semibold">{item.title}</h3>

                        <p className="mt-1 text-sm text-gray-500">
                          {item.description}
                        </p>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p className="mt-2 text-sm text-gray-500">
                  No Terms & Conditions found. Click here to create one.
                </p>
              )}
            </div>
          </DialogContent>

          <DialogActions>
            <Button onClick={() => setOpenTCModal(false)}>Close</Button>
          </DialogActions>
        </Dialog>
      }
      {
        <Dialog
          open={openCreateTCModal}
          onClose={() => setOpenCreateTCModal(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Create Terms & Conditions</DialogTitle>

          <DialogContent dividers>
            <div className="space-y-4 pt-2">
              <TextField
                fullWidth
                label="Title"
                value={newTC.title}
                onChange={(e) =>
                  setNewTC((prev) => ({
                    ...prev,
                    title: e.target.value,
                  }))
                }
              />

              <TextField
                fullWidth
                multiline
                rows={4}
                label="Description"
                value={newTC.description}
                onChange={(e) =>
                  setNewTC((prev) => ({
                    ...prev,
                    description: e.target.value,
                  }))
                }
              />
            </div>
          </DialogContent>

          <DialogActions>
            <Button onClick={() => setOpenCreateTCModal(false)}>Cancel</Button>

            <Button
              variant="contained"
              disabled={
                !newTC.title.trim() ||
                !newTC.description.trim() ||
                disableButtonCheck
              }
              onClick={createTermsCondition}
            >
              Submit
            </Button>
          </DialogActions>
        </Dialog>
      }
    </div>
  );
};

export default TermsAndConditionsModal;
